import { Component } from '@angular/core';

@Component({
    selector: 'app-customer-support-info',
    templateUrl: './customer-support-info.component.html',
    styleUrls: ['./customer-support-info.component.scss'],
    standalone: false
})
export class CustomerSupportInfoComponent {
     // Adding a comment to trigger a build
}
